<app-self-checkin kind="venue" [targetId]="targetId"></app-self-checkin>
